export default __webpack_public_path__ + "static/BasisGrotesque-Bold-73319215f97df9697d341ed7b7028b71.woff2";